import { render, staticRenderFns } from "./courseIndex.vue?vue&type=template&id=5e84bd3c&scoped=true&"
import script from "./courseIndex.vue?vue&type=script&lang=js&"
export * from "./courseIndex.vue?vue&type=script&lang=js&"
import style0 from "./courseIndex.vue?vue&type=style&index=0&id=5e84bd3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e84bd3c",
  null
  
)

export default component.exports